import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form';
import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { DataService } from 'src/app/services/data.service';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { TeslaAutocompleteComponent } from '@tesla/angular2-tesla-common/autocomplete/autocomplete.component';
import { AppSettings } from 'src/app/app.settings';
import { PartSystemDTO } from 'src/app/models/external/partsystem-dto';
import { PEAssignment } from 'src/app/models/pe-assignment';
import { ReassignPackageEngineerDTO } from '../../../models/reassign-packageengineerDTO';

@Component({
  selector: 'app-reassign-pe',
  templateUrl: './reassign-pe.component.html',
  styleUrls: ['./reassign-pe.component.scss']
})
export class ReassignPeComponent implements OnInit {
  currentlySelectedAssignmentDTOList: any;
  reassignPEInfoForm: FormGroup;
  public formErrors;
  @ViewChild('PEAutoComplete') PEAutoComplete: TeslaAutocompleteComponent;
  autoCompletePEURL: string;
  partSystemList: PartSystemDTO[];

  constructor(
    private dialogRef: MatDialogRef<ReassignPeComponent>,
    @Inject(MAT_DIALOG_DATA) public CurrentAssignmentsInfo: any,

    private fb: FormBuilder,
    private formService: FormService,
    private dataService: DataService,
    private toastService: ToastService,
    private localstorageService: LocalstorageService,
    private appSettings: AppSettings,) {

    this.appSettings = appSettings;
    this.autoCompletePEURL = this.appSettings.Packaging2APIUrl + '/peassignment/pe/all';
    this.currentlySelectedAssignmentDTOList = CurrentAssignmentsInfo;
  }

  ngOnInit() {
    this.reassignPEInfoForm = this.fb.group({
      PEId: null
    });

    this.formErrors = {
      PEId: ''
    };
  }

  onEmptyPE(eventObj: any): void {
    this.PEAutoComplete.list = [];
  }

  updatePEAssignment(){
      var assignmentsToUpdate: any[] = [];
      var reassignFromDetailsScreen = false;
      var currentlySelectedAssignment =
          this.currentlySelectedAssignmentDTOList[0];

      this.currentlySelectedAssignmentDTOList.forEach((item) => {
          const peAssignmentDTO = new PEAssignment();
          peAssignmentDTO.EngineerUserId =
              this.reassignPEInfoForm.controls['PEId'].value;
          peAssignmentDTO.Id = item.Id;
          peAssignmentDTO.SourceTypeId = item.SourceTypeId;
          peAssignmentDTO.PartCategoryId = item.PartCategoryId;
          peAssignmentDTO.SupplierCode = item.SupplierCode;
          peAssignmentDTO.SioCodeId = item.SIOCodeId;
          reassignFromDetailsScreen =
              reassignFromDetailsScreen || item.ReassignFromDetailsScreen;
          assignmentsToUpdate.push(peAssignmentDTO);
      });

      if (reassignFromDetailsScreen) {
          var assignmentToUpdate = assignmentsToUpdate[0];
          assignmentToUpdate.PartNumber =
              currentlySelectedAssignment.PartNumber;

          this.dataService
              .reassignFromDetailsScreen(assignmentToUpdate)
              .subscribe((response: any) => {
                  if (response != null && response.Success) {
                      this.dialogRef.close();
                      this.toastService.success(
                          `Proposals for the location "${currentlySelectedAssignment.SourceTypeDescription}" 
                        in the category "${currentlySelectedAssignment.PartCategoryDescription}", 
                        with part number prefix "${currentlySelectedAssignment.PartNumber}", 
                        have been successfully assigned to the new package engineer.`
                      );
                  } else {
                      this.toastService.error('Update request cancelled');
                  }
              });
      } else {
          this.dataService
              .updatePEAssignment(assignmentsToUpdate)
              .subscribe((response: any) => {
                  if (response != null && response.Success) {
                      this.dialogRef.close();
                      this.toastService.success(
                          'Selected assignment(s) updated'
                      );
                  } else {
                      this.toastService.error('Update request cancelled');
                  }
              });
      }
  }
}
